module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "epslf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Thus altering Age leads on the World to Fate,")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("The Earth is different from her former state.")])]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—Lucretius, "), _c('i', [_vm._v("De rerum natura")]), _vm._v(" (Thomas Creech translation, 1682)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-504a3652","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-menely-0005.vue
// module id = 66
// module chunks = 0